/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';
import { getTokenId } from '@atlaskit/tokens/token-ids';

import { type TransformedTokenGrouped } from '../types';

type TokenLifecycleProps = {
	isLoading?: boolean;
	transformedToken?: TransformedTokenGrouped;
};

const styles = css({
	margin: 0,
	color: token('color.text.subtlest'),
	fontSize: 12,
});

const TokenLifecycle = (props: TokenLifecycleProps) => {
	const { isLoading, transformedToken } = props;

	if (isLoading || !transformedToken) {
		return null;
	}

	return (
		<p css={styles}>
			Introduced v{transformedToken.attributes.introduced}
			{'deprecated' in transformedToken.attributes &&
				` → Deprecated v${transformedToken.attributes.deprecated}`}
			{'deleted' in transformedToken.attributes &&
				` → Deleted v${transformedToken.attributes.deleted}`}
			{'replacement' in transformedToken.attributes &&
				`. Replace with ${
					Array.isArray(transformedToken.attributes.replacement)
						? transformedToken.attributes.replacement.map(
								(replacement, i) => `${getTokenId(replacement)}${i > 0 ? ' / ' : ' '}`,
							)
						: getTokenId(transformedToken.attributes.replacement)
				}`}
		</p>
	);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default TokenLifecycle;
